import createHistory from 'history/createBrowserHistory';
import Analytics from './tools/Analytics';

const history = createHistory();
history.listen((location) => {
  Analytics.trackPage(location.pathname);
});

export default history;


// WEBPACK FOOTER //
// ./src/history.js